import './custom-btn.styles.scss';
import { Loading } from 'carbon-components-react';

const CustomButton = ({ children, classes, isLoading, ...otherProps }) => (
  <button
    type="button"
    className={`bx--btn bx--btn--primary custom-btn ${classes}`}
    {...otherProps}
    disabled={isLoading || otherProps.disabled}
  >
    {isLoading ? (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loading withOverlay={false} small={true} />
      </span>
    ) : (
      children
    )}
  </button>
);

export default CustomButton;

// import React from 'react';
// import './custom-btn.styles.scss';

// const CustomButton = ({ children, classes, ...otherProps }) => (
//   <button
//     type="button"
//     className={`bx--btn bx--btn--primary custom-btn ${classes}`}
//     {...otherProps}>
//     {children}
//   </button>
// );

// export default CustomButton;
